import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IAddCandidateSchema } from '../types';
import { CandidateRow } from './candidate-row';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center' },
  { id: 'firstName', label: 'Name', align: 'center' },
  { id: 'email', label: 'Email', align: 'center' },
  { id: 'phone', label: 'Phone', align: 'center', sortable: false },
  { id: 'source', label: 'Source', align: 'center' },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
  { id: 'reason', label: 'Reason', align: 'center', sortable: false },
  { id: 'action', label: 'Action', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  rows?: IAddCandidateSchema[];
  loading: boolean;
}

const CandidateList = ({ tableProps, rows, loading }: Props) => (
  <PaginatedTable<IAddCandidateSchema>
    head={TABLE_HEAD}
    tableProps={tableProps}
    data={rows}
    loading={loading}
    isServerSidePaging={false}
  >
    {(row) => (
      <CandidateRow
        row={row}
        selected={tableProps.selected.includes(row.id)}
        onSelectRow={() => {
          ('');
        }}
      />
    )}
  </PaginatedTable>
);
export { CandidateList };
